// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import type { Filter } from '../../types/shoppingCenterType';
import type { History } from '../../types/commonTypes';
import type { OfficePartial } from '../../types/OfficesType';
import { applyFilters } from '../../state/offices/officesService';
import { OFFICE_INFO } from '../../path/officePath';
import { officeAppliedFiltersInitial } from '../../state/offices/officesReducer';

type Props = {
  citiesList: string[],
  officeList: OfficePartial[],
  applyFilters: Function,
  history: History,
  filteredOfficeRequest: string,
  officeAppliedFilters: Filter[],
}

type State = {
  selectedFilter: string,
}

class OfficesFilters extends React.Component<Props, State> {
  state: State = {
    selectedFilter: '',
  };

  addSelectedFilter = (filter) => {
    const currentFilter = this.getCurrentSelectedFilter();
    if (currentFilter.selected.includes(filter)) {
      currentFilter.selected =
        currentFilter.selected.filter(elt => elt !== filter);
    } else {
      currentFilter.selected.push(filter);
    }
    this.props.applyFilters(this.props.officeAppliedFilters, this.props.filteredOfficeRequest);
  };

  clearFilter = () => {
    this.props.officeAppliedFilters.forEach((filter) => {
      filter.selected = [];
    });
    this.props.applyFilters(officeAppliedFiltersInitial, '');
    this.setState({
      selectedFilter: '',
    });
  };

  getCurrentFilterList = () => {
    if (this.state.selectedFilter === I18n.t('filters.CITIES')) {
      return this.props.citiesList;
    }
    return [];
  };

  getCurrentSelectedFilter = (): Filter => {
    const arr = this.props.officeAppliedFilters
      .filter(elt => elt.label === this.state.selectedFilter);
    return arr[0];
  };

  updateSearchValue = (value) => {
    this.props.applyFilters(this.props.officeAppliedFilters, value);
  };

  render() {
    return (
      <div className="filters">
        <div
          role="presentation"
          onClick={e => e.stopPropagation()}
          className="filter-first-step"
        >
          <div className={`search-input${this.props.filteredOfficeRequest === '' ? ' empty' : ''}`}>
            <input
              onChange={e => this.updateSearchValue(e.target.value)}
              placeholder="&#xF002;"
              value={this.props.filteredOfficeRequest}
            />
          </div>
          {
            this.props.officeAppliedFilters.map(filter => (
              <button
                key={filter.label}
                onClick={() => this.setState({ selectedFilter: filter.label })}
                className={`search-filter ${this.state.selectedFilter === filter.label ? 'active' : ''}`}
              >
                <div className="filter-title">{filter.label}</div>
                {
                  filter.selected.length > 0 && (
                    <div className="filter-title">
                      {`${
                        filter.selected.length > 1 ?
                          `${filter.selected.length} ${I18n.t('filters.selected')}` :
                          filter.selected[0]
                        }`}
                    </div>
                  )
                }
              </button>
            ))
          }
          <button
            onClick={this.clearFilter}
            className="apollo-button"
          >
            <Translate value="filters.CLEAR_ALL_FILTER" />
          </button>
        </div>
        {
          this.getCurrentSelectedFilter() && (
            <div
              role="presentation"
              onClick={e => e.stopPropagation()}
              className="filter-second-step"
            >
              <div className="second-step-title">
                {this.state.selectedFilter}&nbsp;<Translate value="filters.FILTER" />
                <button onClick={() => this.setState({ selectedFilter: '' })}>
                  <i className="fas fa-times-circle icon" />
                </button>
              </div>
              <div className="filter-container">
                {
                  this.getCurrentFilterList()
                    .map(filter => (
                      <button
                        key={filter}
                        onClick={() => this.addSelectedFilter(filter)}
                        className="search-filter"
                      >
                        <div className="filter-title">{filter}</div>
                        {
                          this.getCurrentSelectedFilter().selected.includes(filter) &&
                          <i className="fas fa-check icon" />
                        }

                      </button>
                    ))
                }
              </div>
              <div>
                <button
                  onClick={this.clearFilter}
                  className="apollo-button"
                >
                  <Translate value="filters.CLEAR_FILTER" />
                </button>
              </div>
            </div>
          )
        }
        <div
          role="presentation"
          onClick={e => e.stopPropagation()}
          className="filter-third-step"
        >
          <div className="third-step-title">
            <Translate value="filters.offices" />
          </div>
          <div className="filter-container">
            {
              this.props.officeList
                .map(office => (
                  <button
                    key={office.code}
                    onClick={() => this.props.history.push(`${OFFICE_INFO}?office=${office.id}`)}
                    className="search-filter"
                  >
                    <div className="filter-title">{office.name}</div>
                  </button>
                ))
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(state => ({
  citiesList: state.office.officesCitiesList,
  officeList: state.office.officeList,
  filteredOfficeRequest: state.office.filteredOfficeRequest,
  officeAppliedFilters: state.office.officeAppliedFilters,
}), { applyFilters })(OfficesFilters));
